<template>
  <popup-modal ref="popup">
    <v-card>
      <v-toolbar color="primary" dark>
        {{inputData.title}}
      </v-toolbar>

      <v-card-text class="mt-4">

        <form>
          <v-row>
            <v-col cols="5">
              <div v-html="inputData.description" style="margin-top: 20px">
              </div>
            </v-col>
            <v-col cols="7">
              <v-select
                  :items="getLocationsFilter"
                  item-text="name"
                  item-value="id"
                  label="Локация"
                  prepend-icon="mdi-map-marker-outline"
                  v-model="form.location"
              ></v-select>

              <v-file-input
                  show-size
                  label="Файл для отправки"
                  v-model="form.file"
              ></v-file-input>

              <v-file-input
                      show-size
                      label="Сопроводительные документы"
                      v-model="form.additional_files"
                      multiple
              ></v-file-input>

              <v-textarea
                  label="Комментарий"
                  v-model="form.comment"
                  prepend-icon="mdi-comment-outline"
              ></v-textarea>
            </v-col>
          </v-row>
        </form>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn @click="Negative" text>{{ $t('common.button_cancel') }}</v-btn>
        <v-btn @click="Positive" color="primary">{{ $t('common.button_send') }}</v-btn>
      </v-card-actions>
    </v-card>
  </popup-modal>
</template>

<script>
import PopupModal from "@/components/PopupModal";
import { mapGetters } from "vuex"
// eslint-disable-next-line
import {downloadBase64File, fileToBase64, selectFile} from "@/domain/utils";

export default {
  name: "DialogAddTicket",
  components: { PopupModal },
  data: () => ({

    inputData: {title:""},

    form:{
      file: undefined,
      additional_files: undefined,
      location:undefined,
      comment:"",
    },


    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {



    show(opts = {}) {
      console.log(opts)
      this.inputData = opts
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open(false, true, 900);
      this.form = {
                    file: undefined,
                    additional_files: undefined,
                    location:undefined,
                    comment:"",
                  }

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    Positive() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "positive", form: this.form });
    },
    Negative() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "negative" });
    },
  },
  computed:{
    ...mapGetters('app',["getLocationsFilter"]),
    // locations(){
    //   return ["Локация 1","Локация 2","Локация 3"]
    // }
  },
};
</script>
